import useTitle from '@/hooks/useTitle';
import { Box } from '@mui/system';
import { useParams } from 'react-router-dom';
import CallDetails from '@/components/forms/calls/CallDetails';
import { useState } from 'react';
import { useEffect } from 'react';
import api from '@/services/ApiService';
import { Card } from '@mui/material';

export default function callInfo() {
  useTitle('Anruf');

  const { id } = useParams();

  const [call, setCall] = useState({});

  useEffect(() => {
    const fetchCall = async () => {
      if (id) {
        const { data: call } = await api.get(`call/${id}`);
        setCall(call);
      }
    };

    fetchCall();
  }, [id]);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Card sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <CallDetails data={call} />
      </Card>
    </Box>
  );
}
